import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { graphql } from "relay-runtime"
import { useUpdateNewsMutation } from "@/modules/admin/news/services/__generated__/useUpdateNewsMutation.graphql"

const mutation = graphql`
  mutation useUpdateNewsMutation($input: UpdateNewsInput!) {
    updateNews(input: $input) {
      news {
        id
        isShowing
        ...NewsFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
const useUpdateNewsNotificationMutation = () => {
  const [commit, isFlight] = useMutation<useUpdateNewsMutation>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useUpdateNewsMutation>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useUpdateNewsNotificationMutation }
